export default class ContentfulFactory {
  static createSys(contentTypeId) {
    return {
      contentType: {
        sys: {
          id: contentTypeId,
        },
      },
    };
  }
}
